import {
  createSelectorHooks,
  ZustandHookSelectors
} from 'auto-zustand-selectors-hook'
import create from 'zustand'

interface Order {
  orderId: string
  isModalOpen: boolean
  setModalIsOpen: (open: boolean) => void
  setOrderId: (orderId: string) => void
}

const useStoreBase = create<Order>()((set) => ({
  orderId: '',
  isModalOpen: false,
  setModalIsOpen: (isModalOpen: boolean) => set(() => ({ isModalOpen })),
  setOrderId: (orderId: string) => set(() => ({ orderId }))
}))

export const useNfeModalStore = createSelectorHooks(
  useStoreBase
) as typeof useStoreBase & ZustandHookSelectors<Order>
